export default "__VITE_ASSET__CWbYJm74__"